import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { GraduationCap, Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
      <div className="hidden lg:flex bg-marino text-white p-12 flex-col justify-between relative overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1556761175-4b46a572b786?w=1200")', backgroundSize: 'cover' }} />
        <div className="relative flex items-center gap-3">
          <img src="/shield-ompec.svg" alt="OM-PEC" className="h-14 w-auto" />
          <div>
            <span className="font-heading font-black text-2xl block">OM-PEC</span>
            <span className="text-[10px] uppercase tracking-wider text-naranja font-semibold">Protegemos · Fortalecemos</span>
          </div>
        </div>
        <div className="relative">
          <h2 className="font-heading font-black text-4xl tracking-tight leading-tight">Recupera tu acceso</h2>
          <p className="mt-3 text-white/80 max-w-md">Te enviaremos un enlace seguro para que crees una nueva contraseña.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-10 bg-white">
        <div className="w-full max-w-md">
          {sent ? (
            <div data-testid="forgot-sent" className="text-center animate-fade-in">
              <div className="w-14 h-14 rounded-full bg-green-100 text-green-700 flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-8 h-8" />
              </div>
              <h1 className="font-heading font-black text-2xl text-marino">Revisa tu correo</h1>
              <p className="mt-3 text-marino/70">Si el email <strong>{email}</strong> existe en OM-PEC, recibirás un enlace para restablecer tu contraseña. El enlace expira en 1 hora.</p>
              <Link to="/login" data-testid="back-to-login" className="mt-6 inline-block bg-gris text-marino px-5 py-2 rounded-lg font-medium hover:bg-grisHover">Volver al inicio de sesión</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div>
                <h1 className="font-heading font-black text-3xl text-marino tracking-tight">¿Olvidaste tu contraseña?</h1>
                <p className="mt-1 text-marino/70 text-sm">Ingresa tu email y te enviaremos un enlace para restablecerla.</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-marino mb-1">Email</label>
                <div className="relative">
                  <Mail className="w-4 h-4 text-gris absolute left-3 top-1/2 -translate-y-1/2" />
                  <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full pl-9 pr-4 py-3 border border-gris rounded-lg focus:border-marino focus:outline-none" />
                </div>
              </div>
              {err && <div data-testid="forgot-error" className="text-naranja text-sm bg-naranja/10 border border-naranja/30 rounded-lg p-3">{err}</div>}
              <button disabled={loading} data-testid="forgot-submit" className="w-full bg-naranja text-white py-3 rounded-lg font-semibold hover:bg-naranjaHover disabled:opacity-60">
                {loading ? "Enviando..." : "Enviar enlace"}
              </button>
              <p className="text-sm text-marino/70 text-center">
                <Link to="/login" className="text-naranja font-medium">← Volver a iniciar sesión</Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
